<template>
  <md-list class="photo-list">
    <md-content class="md-scrollbar">
      <template v-for="[name, photos] in orderedPhotosByConcept">
        <div :key="name">
          <h4>{{ nameFilter(name) }}</h4>
          <md-divider class="md-inset"></md-divider>
          <image-matrix
            ref="imageMatrix"
            :images="photos"
            :show-labels="showLabels"
            :use-file-icons="useFileIcons"
            :imageActions="imageActions"
            :columnSize="20"
            @openVisor="openVisor"
            @openLink="openLink"
          >
            <template slot="image-actions" slot-scope="sScope">
              <slot name="image-actions" v-bind="sScope"></slot>
            </template>
          </image-matrix>
        </div>
      </template>

      <md-divider class="md-inset"></md-divider>

      <template v-if="!isExtranet">
        <div
          v-for="(concept, index) in orderedMissingConcepts"
          :key="index"
          class="missing-concept"
        >
          <strong>{{ concept }}</strong>
          (Sin fotos)
          <md-icon>close</md-icon>
          <md-divider class="md-inset"></md-divider>
        </div>
      </template>
    </md-content>
    <slot></slot>

    <LightBox
      :images="lightImages"
      ref="lightbox"
      :show-caption="true"
      :show-light-box="false"
      :site-loading="imageLoading"
    ></LightBox>
  </md-list>
</template>

<script>
import ImageMatrix from "@/components/Outputs/Images/Matrix";
import LightBox from "vue-image-lightbox";
import imageLoading from "@/assets/images/loading.gif";

export default {
  name: "PhotoList",

  components: {
    ImageMatrix,
    LightBox,
  },

  props: {
    value: {
      type: Object,
      required: true,
      validator(value) {
        for (const [key, entryValue] of Object.entries(value)) {
          if (!Array.isArray(entryValue)) {
            return false;
          }
          const validPhotos = entryValue.every(
            ({ conceptName, src }) => !!conceptName && !!src
          );
          if (!validPhotos) {
            return false;
          }
        }

        return true;
      },
    },
    conceptsOrder: {
      type: Array,
      default: () => [],
    },
    missingConcepts: {
      type: Array,
      required: false,
      default: () => [],
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    imageActions: {
      type: Boolean,
      default: false,
    },
    useFileIcons: {
      props: Boolean,
      default: false,
    },
    isExtranet: {
      type: Boolean,
      default: false,
    },
    nameFilter: {
      type: Function,
      default: (s) => `${s}`,
    },
  },

  methods: {
    openVisor(photoObj) {
      const conceptName = photoObj.conceptName;
      const images = this.value[conceptName];

      this.lightImages = images;

      const index = images.indexOf(photoObj);
      this.$refs.lightbox.showImage(index);
    },
    openLink({ src }) {
      const win = window.open(src, "_blank");
      win.focus();
    },
  },

  data() {
    return {
      lightImages: [],
      imageLoading,
    };
  },
  computed: {
    orderedPhotosByConcept() {
      const { value: originalPhotosByConcept, conceptsOrder } = this;
      const value = {
        ...originalPhotosByConcept,
      };

      const orderedList = [];
      for (const concept of conceptsOrder || []) {
        const li = value[concept];
        if (li) {
          orderedList.push([concept, li]);
          delete value[concept];
        }
      }

      return [...orderedList, ...Object.entries(value)];
    },

    orderedMissingConcepts() {
      const { missingConcepts, conceptsOrder } = this;

      return [
        ...conceptsOrder.filter((c) => missingConcepts.includes(c)),
        ...missingConcepts.filter((c) => !conceptsOrder.includes(c)),
      ];
    },
  },
};
</script>

<style lang="css" scoped>
.md-list {
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid rgba(#000, 0.12);
}

.missing-concept,
.missing-concept > .md-icon.md-icon-font {
  color: red !important;
}

.photo-list {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Outputs/PhotoList.vue